export function extractFileName(fileId: string): string {
  const segments = fileId.split('/')
  const last = segments[segments.length - 1] || fileId
  const parts = last.split('.')
  if (parts.length >= 3) {
    return parts.slice(0, -2).join('.')
  }
  if (parts.length === 2) {
    return parts[0]
  }
  return last
}
